import { JetBrains_Mono, Pixelify_Sans } from 'next/font/google'

// JetBrains Mono powers the ASCII canvas art and every uppercase mono label.
export const jetBrainsMono = JetBrains_Mono({
    subsets: ['latin'],
    weight: ['400', '500', '600'],
    variable: '--font-jetbrains-mono',
    display: 'swap'
})

// Pixelify Sans is the chunky bitmap face used only for the large section titles.
export const pixelifySans = Pixelify_Sans({
    subsets: ['latin'],
    weight: ['400', '500', '600', '700'],
    variable: '--font-pixelify-sans',
    display: 'swap'
})

// Family strings safe to hand straight to canvas `ctx.font` and inline styles.
export const MONO_FAMILY = `${jetBrainsMono.style.fontFamily}, ui-monospace, SFMono-Regular, Menlo, monospace`
export const PIXEL_FAMILY = `${pixelifySans.style.fontFamily}, system-ui, sans-serif`
